<template>
   <f7-page>
    <f7-navbar>
      <f7-nav-title class="text-madai">Carrito</f7-nav-title>
    </f7-navbar>
    <!-- Hay elementos en el carrito -->
    <template v-if="storage.carrito.length">
      <img class="wd-100" src="assets/img/banners/shopping.png" alt="">
      <f7-row v-if="!carritoValido" class="p-10">
        <div class="text-center fs-15 bold alert alert-danger-2 alert-shadow m-b-0">Para continuar con el proceso de pago es necesario que primero selecciones una medida.</div>
      </f7-row>
      <!-- Mis Artículos -->
      <f7-card>
        <f7-card-header class="bg-madai">
          <span class="text-white bold">Mis artículos</span>
        </f7-card-header>
        <f7-card-content :padding="false">
          <f7-list class="m-t-0 m-b-0">
            <f7-list-item
              v-for="(itm, idx) in storage.carrito"
              :key="idx"
            >

            <list-argolla v-if="itm.ida_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-argolla>
            <list-cadena v-else-if="itm.id_chain" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-cadena>
            <list-churumbela v-else-if="itm.idc_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-churumbela>
            <list-compromiso v-else-if="itm.idac_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-compromiso>
            <list-promesa v-else-if="itm.idp_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-promesa>
            <list-zirconia v-else-if="itm.ida_zirconia" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-zirconia>
            <list-diamante v-else-if="itm.IdDiamond" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito"></list-diamante>
            <list-aretes v-else-if="itm.idar_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-aretes>
            <list-dije v-else-if="itm.iddj_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-dije>
            <list-pulso v-else-if="itm.idpul_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-pulso>
            <list-conjunto v-else-if="itm.idcj_articles" :idx="idx" :promocion="articulosPromo" @validar="validarBotonCarrito" @galeria="abrirGaleria(itm.img_ext.split('|'))"></list-conjunto>

            </f7-list-item>
          </f7-list>
        </f7-card-content>
      </f7-card>
      <!-- Total de la orden -->
      <f7-card>
        <f7-card-header class="bg-madai">
          <span class="text-white bold">Total de la orden</span>
        </f7-card-header>
        <f7-card-content :padding="false">
          <f7-list>
            <f7-list-item>
              <span class="bold">Subtotal: </span><span class="bold text-madai" style="float: right;"> {{ $helper.str.formatearMoneda(subtotal) }}</span>
            </f7-list-item>
            <f7-list-item>
              <span class="bold">Costo de envío: </span>
              <!-- <span class="bold text-madai" :class="{ strike: envio === false }" style="float: right;">$300.00</span> -->
            </f7-list-item>
            <f7-list-item>
              <f7-list class="wd-100 f7-list-item-no-padding f7-list-item-after" media-list>
                <f7-list-item radio title="Paquetería" :after="`$ ${master.GASTO_ENVIO_WEB.toFixed(2)}`"
                  name="tipo-envio"
                  value="paqueteria"
                  :checked="tipoEnvio === 'paqueteria'"
                  @change="tipoEnvio = $event.target.value"
                ></f7-list-item>
                <f7-list-item radio title="Recoger en Tienda" after="$ 0.00"
                  name="tipo-envio"
                  value="tienda"
                  :checked="tipoEnvio === 'tienda'"
                  @change="tipoEnvio = $event.target.value"
                ></f7-list-item>
              </f7-list>
            </f7-list-item>
            <f7-list-item>
              <span class="bold">Agregar cupón de descuento: </span>
            </f7-list-item>
            <f7-list-input
              label="Cupón de descuento"
              class="green"
              type="text"
              placeholder="Ingresa el código"
              :info="storage.cupon.valido ? `Cupón válido por un ${storage.cupon.porcentaje}% de descuento` : ''"
              :value="storage.cupon.codigo"
              @input="storage.cupon.codigo = $event.target.value; validarCupon($event.target.value)"
              :error-message-force="storage.cupon.valido === false && storage.cupon.codigo.length > 0"
              error-message="Clave no válida"
            >
            </f7-list-input>
            <f7-list-item v-if="ahorro > 0">
              <span class="bold">Tu ahorro: </span><span class="bold" style="float: right; color: #41ad49;"> {{ $helper.str.formatearMoneda(ahorro) }}</span>
            </f7-list-item>
            <f7-list-item>
              <span class="bold">Total de la orden: </span><span class="bold text-madai" style="float: right;"> {{ $helper.str.formatearMoneda(total) }}</span>
            </f7-list-item>
          </f7-list>
        </f7-card-content>
      </f7-card>
      <!-- Imagenes paypal y tarjeta de crédito -->
      <template v-if="storage.carrito.length">
        <f7-row>
          <f7-col class="text-center" width="60">
            <img src="assets/img/otros/paypal-secure.png" alt="" style="border-radius: 10px;" height="70">
          </f7-col>
          <f7-col class="text-left" width="40">
            <img src="assets/img/otros/credito-secure.png" alt="" style="border-radius: 10px;" height="70">
          </f7-col>
        </f7-row>
      </template>
      <!-- Forma de pago -->
      <f7-card v-if="carritoValido">
        <f7-card-header class="bg-madai">
          <span class="text-white bold">Selecciona tu forma de pago</span>
        </f7-card-header>
        <f7-card-content :padding="false">
          <template>
            <f7-list class="m-t-0">
              <f7-list-item
                radio
                title="Paypal"
                name="formaPago"
                value="paypal"
                :checked="formaPago === 'paypal'"
                @change="formaPago = $event.target.value"
              ></f7-list-item>
              <f7-list-item
                radio
                title="Tarjeta Visa o Mastercard"
                name="formaPago"
                value="tarjeta"
                :checked="formaPago === 'tarjeta'"
                @change="formaPago = $event.target.value"
              ></f7-list-item>
            </f7-list>
            <template v-if="formaPago === 'paypal'">
              <hr>
              <f7-row class="p-10">
                <f7-col class="text-center">
                  <paypal
                    v-if="paypalButton === false"
                    locale="es_MX"
                    :amount="(total).toFixed(2)"
                    currency="MXN"
                    :client="credentials"
                    :env="false ? 'sandbox' : 'production'"
                    :items="items"
                    @payment-completed="pagoCompletado"
                    :button-style="paypalStyle"
                  >
                  </paypal>
                </f7-col>
              </f7-row>
            </template>
          </template>
        </f7-card-content>
      </f7-card>
      <!-- Datos de tarjeta -->
      <template v-if="formaPago === 'tarjeta'">
        <f7-card :padding="false" class="p-b-10">
          <f7-card-header class="bg-madai">
            <span class="text-white bold">Datos de Tarjeta</span>
          </f7-card-header>
          <f7-card-content>
            <f7-list>
              <f7-list-item title="Tipo de tarjeta" smart-select :smart-select-params="{openIn: 'popup'}" class="required m-t-15">
                <select name="tipoTarjeta" v-model="storage.transaccion.payer.payment_method">
                  <option value="visa">Visa</option>
                  <option value="mastercard">Master Card</option>
                </select>
              </f7-list-item>
              <f7-list-input
                class="required m-t-10"
                label="Número de tarjeta"
                type="text"
                maxlength="19"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="16 dígitos"
                :value="storage.usuario.tarjeta.numero"
                @input="storage.usuario.tarjeta.numero = formatearTarjeta($event.target.value)"
              ></f7-list-input>
              <f7-list-input
                class="required"
                label="Fecha en que expira (MM/AA)"
                type="text"
                maxlength="5"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="MM/AA"
                :value="storage.usuario.tarjeta.expira"
                @input="storage.usuario.tarjeta.expira = formatearFecha($event.target.value)"
              ></f7-list-input>
              <f7-list-input
                class="required"
                label="CVV"
                type="text"
                maxlength="3"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="CVV"
                :value="storage.usuario.tarjeta.cvv"
                @input="storage.usuario.tarjeta.cvv = $event.target.value"
              ></f7-list-input>
            </f7-list>
          </f7-card-content>
        </f7-card>
      </template>
      <!-- Dirección de facturación -->
      <template v-if="formaPago === 'tarjeta'">
        <f7-card :padding="false" class="p-b-10">
          <f7-card-header class="bg-madai">
            <span class="text-white bold">Dirección de facturación</span>
          </f7-card-header>
          <f7-card-content>
            <f7-row class="bold m-b-15">
              Selecciona la información que coinicida con tu tarjeta o forma de pago.
            </f7-row>
            <f7-list no-hairlines-md class="m-t-0">
              <f7-list-input
                class="required"
                label="Nombre"
                type="text"
                placeholder="Escribe tu nombre"
                error-message="Nombre no válido"
                :error-message-force="storage.transaccion.payer.payer_info.first_name.length > 0 && storage.transaccion.payer.payer_info.first_name.length < 4"
                :value="storage.transaccion.payer.payer_info.first_name"
                @input="storage.transaccion.payer.payer_info.first_name = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Apellidos"
                type="text"
                placeholder="Escribe tus apellidos"
                error-message="Apellido no válido"
                :error-message-force="storage.transaccion.payer.payer_info.last_name.length > 0 && storage.transaccion.payer.payer_info.last_name.length < 4"
                :value="storage.transaccion.payer.payer_info.last_name"
                @input="storage.transaccion.payer.payer_info.last_name = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Correo"
                type="email"
                placeholder="Escribe el correo"
                error-message="Correo no válido"
                :error-message-force="storage.transaccion.payer.payer_info.email.length > 0 && validarCorreo(storage.transaccion.payer.payer_info.email) === false"
                :value="storage.transaccion.payer.payer_info.email"
                @input="storage.transaccion.payer.payer_info.email = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Teléfono o Celular"
                type="text"
                placeholder="Escribe el número"
                error-message="Número inválido, ej. 81185751440"
                maxlength="10"
                :error-message-force="storage.transaccion.payer.payer_info.phone.length > 0 && validarTelefono(storage.transaccion.payer.payer_info.phone) === false"
                :value="storage.transaccion.payer.payer_info.phone"
                @input="storage.transaccion.payer.payer_info.phone = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Calle y Número"
                type="text"
                placeholder="Escribe nombre de la calle"
                error-message="Dirección no válida"
                :error-message-force="storage.transaccion.payer.payer_info.shipping_address.line1.length > 0 && storage.transaccion.payer.payer_info.shipping_address.line1.length < 4"
                :value="storage.transaccion.payer.payer_info.shipping_address.line1"
                @input="storage.transaccion.payer.payer_info.shipping_address.line1 = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Colonia"
                type="text"
                placeholder="Escribe la colonia"
                error-message="Nombre de colonia no válido"
                :error-message-force="storage.transaccion.payer.payer_info.shipping_address.suburb.length > 0 && storage.transaccion.payer.payer_info.shipping_address.suburb.length < 4"
                :value="storage.transaccion.payer.payer_info.shipping_address.suburb"
                @input="storage.transaccion.payer.payer_info.shipping_address.suburb = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Código Postal"
                type="text"
                placeholder="Escribe el código postal"
                error-message="Código postal no válido"
                :error-message-force="storage.transaccion.payer.payer_info.shipping_address.postal_code.length > 0 && storage.transaccion.payer.payer_info.shipping_address.postal_code.length < 5"
                :value="storage.transaccion.payer.payer_info.shipping_address.postal_code"
                @input="storage.transaccion.payer.payer_info.shipping_address.postal_code = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Ciudad"
                type="text"
                placeholder="Escribe la ciudad"
                error-message="Ciudad no válida"
                :error-message-force="storage.transaccion.payer.payer_info.shipping_address.city.length > 0 && storage.transaccion.payer.payer_info.shipping_address.city.length < 4"
                :value="storage.transaccion.payer.payer_info.shipping_address.city"
                @input="storage.transaccion.payer.payer_info.shipping_address.city = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                class="required"
                label="Estado"
                type="text"
                placeholder="Escribe el estado"
                error-message="Estado no válido"
                :error-message-force="storage.transaccion.payer.payer_info.shipping_address.state.length > 0 && storage.transaccion.payer.payer_info.shipping_address.state.length < 4"
                :value="storage.transaccion.payer.payer_info.shipping_address.state"
                @input="storage.transaccion.payer.payer_info.shipping_address.state = $event.target.value"
              ></f7-list-input>
            </f7-list>

            <f7-button class="wd-100 m-t-20" fill
              @click="pagarTarjeta"
              :disabled="
                storage.usuario.tarjeta.numero.length < 16 ||
                storage.usuario.tarjeta.expira.length < 4 ||
                storage.usuario.tarjeta.cvv.length < 3 ||
                storage.usuario.tarjeta.nombre === '' ||
                validarCorreo(storage.transaccion.payer.payer_info.email) === false ||
                validarTelefono(storage.transaccion.payer.payer_info.phone) === false ||
                storage.transaccion.payer.payer_info.shipping_address.line1.length < 4 ||
                storage.transaccion.payer.payer_info.shipping_address.suburb.length < 4 ||
                storage.transaccion.payer.payer_info.shipping_address.postal_code.length < 5 ||
                storage.transaccion.payer.payer_info.shipping_address.city.length < 4 ||
                storage.transaccion.payer.payer_info.shipping_address.state.length < 4 ||
                pagando === true"
            >
              Realizar pago
            </f7-button>
          </f7-card-content>
        </f7-card>
      </template>
    </template>
    <!-- No hay nada en el carrito -->
    <template v-else>
      <div class="m-t-0 text-center">
        <f7-block class="m-t-20 m-b-15">
          <img class="d-block m-b-25" src="assets/img/otros/logo_bg.jpg" alt="" width="150" style="margin: 0 auto;">
          <div class="alert alert-secondary bold fs-16 m-t-50" style="display: inline !important;">Aún no has agregado nada a tu carrito.</div>
        </f7-block>
        <img src="assets/img/otros/carrito_vacio.jpg" alt="" width="80%">
      </div>
    </template>
    <!-- Footer -->
    <f7-block class="p-8 m-t-10">
      <template v-if="carrito.length">
        <div class="text-center m-b-30">
          <img src="assets/img/otros/ssl-secure.jpg" alt="" style="border-radius: 10px;" height="40">
        </div>
      </template>
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block>
    <!-- Popup -->
    <f7-popup class="demo-popup" :opened="ultimosPasos" @popup:closed="ultimosPasos = false">
      <f7-page>
        <f7-navbar class="bg-madai">
          <f7-nav-title class="text-white">
            Últimos pasos
          </f7-nav-title>
        </f7-navbar>
        <img class="wd-100" src="assets/img/banners/gracias.png" alt="">
        <f7-block class="m-t-0">
          <div class="text-dark bold">¡Hola <span style="color:#957bbe;">{{ storage.transaccion.payer.payer_info.shipping_address.recipient_name }}</span>!, agradecemos tu preferencia! Por último necesitamos que confirmes que la dirección de envío sea la correcta.</div>
        </f7-block>
        <f7-list>
          <f7-list-input
            class="required"
            label="Nombre Completo"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.recipient_name"
            @input="storage.transaccion.payer.payer_info.shipping_address.recipient_name = $event.target.value"
            readonly
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Celular"
            type="text"
            maxlength="10"
            placeholder="Escribe tu número de celular"
            error-message="Número inválido, ej. 81185751440"
            :error-message-force="storage.transaccion.payer.payer_info.phone.length > 0 && validarTelefono(storage.transaccion.payer.payer_info.phone) === false"
            :value="storage.transaccion.payer.payer_info.phone"
            @input="storage.transaccion.payer.payer_info.phone = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Correo"
            type="text"
            error-message="Correo no válido"
            :error-message-force="storage.transaccion.payer.payer_info.email.length > 0 && validarCorreo(storage.transaccion.payer.payer_info.email) === false"
            :value="storage.transaccion.payer.payer_info.email"
            @input="storage.transaccion.payer.payer_info.email = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Calle"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.line1"
            @input="storage.transaccion.payer.payer_info.shipping_address.line1 = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Colonia"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.suburb"
            @input="storage.transaccion.payer.payer_info.shipping_address.suburb = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Ciudad"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.city"
            @input="storage.transaccion.payer.payer_info.shipping_address.city = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Estado"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.state"
            @input="storage.transaccion.payer.payer_info.shipping_address.state = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Código Postal"
            type="text"
            :value="storage.transaccion.payer.payer_info.shipping_address.postal_code"
            @input="storage.transaccion.payer.payer_info.shipping_address.postal_code = $event.target.value"
          ></f7-list-input>
          <f7-list-item>
            <f7-row class="wd-100">
              <f7-col width="60">
                <f7-button @click="agregarDireccionEnvio" color="green" fill :disabled="storage.transaccion.payer.payer_info.hasOwnProperty('card_details')">+ Dirección de Envío</f7-button>
              </f7-col>
              <f7-col width="40">
                <f7-button @click="finalizarVenta" fill class="wd-100" :disabled="
                  storage.transaccion.payer.payer_info.shipping_address.recipient_name.length < 3 ||
                  (validarTelefono(storage.transaccion.payer.payer_info.phone) === false) ||
                  (validarCorreo(storage.transaccion.payer.payer_info.email) === false) ||
                  storage.transaccion.payer.payer_info.shipping_address.suburb.length < 4 ||
                  storage.transaccion.payer.payer_info.shipping_address.city.length < 4 ||
                  storage.transaccion.payer.payer_info.shipping_address.state.length < 4 ||
                  storage.transaccion.payer.payer_info.shipping_address.postal_code.length < 5"
                >
                  Confirmar
                </f7-button>
              </f7-col>
            </f7-row>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-popup>
    <!-- Photo Browser -->
    <template v-if="photos.length > 0">
      <f7-photo-browser
        :photos="photos"
        ref="standaloneDark"
        back-link-text="Cerrar"
        navbar-of-text="de"
        @photobrowser:closed="photos = []"
      ></f7-photo-browser>
    </template>
  </f7-page>
</template>

<script>
import listArgolla from '@/components/list-argolla-carrito.vue'
import listCadena from '@/components/list-cadena-carrito.vue'
import listChurumbela from '@/components/list-churumbela-carrito.vue'
import listCompromiso from '@/components/list-compromiso-carrito.vue'
import listPromesa from '@/components/list-promesa-carrito.vue'
import listZirconia from '@/components/list-zirconia-carrito.vue'
import listDiamante from '@/components/list-diamante-carrito.vue'
import listAretes from '@/components/list-aretes-carrito.vue'
import listDije from '@/components/list-dije-carrito.vue'
import listPulso from '@/components/list-pulso-carrito.vue'
import listConjunto from '@/components/list-conjunto-carrito.vue'
import _ from 'lodash'
import * as moment from 'moment'
moment.locale('es')

var timer = null

export default {
  components: {
    listArgolla,
    listCadena,
    listChurumbela,
    listCompromiso,
    listPromesa,
    listZirconia,
    listDiamante,
    listAretes,
    listDije,
    listPulso,
    listConjunto
  },
  data () {
    return {
      master: {
        GASTO_ENVIO_WEB: 0
      },
      carrito: [],
      tipoEnvio: 'paqueteria',
      ahorro: 0,
      articulosPromo: [],
      pagando: false,
      ultimosPasos: false,
      subtotal: 0,
      total: 0,
      credentials: {
        // sandbox: 'ATOGaBUjvXsKYmqnr8gm_g87b8pHjLXJbs-HQhHhY5LLX-IrCmf-6Jy65Y8zEJySkz4HIFJmzu8ZlWrk',
        // production: 'AUjRn1DPnQU9DDfQOnn3Lp50xTpIVo-nga7J7zxOKOoB9WZbwbO_r8ofm9aLJCSXUF_4P6qkFvTAEAj_'
        // contactomadai@gmail.com
        sandbox: 'AW6YF3i3kqj2eAnmdbFP1Cy5hNuF2wlPwS5ITx2DDSrhUDY1NDdGO2GG5GAAqwKvba9xfttA7i42YH8g',
        production: 'AfEpViiIPtRb7oFim5vonPoVx9V5GQIwM-RNx_PivaZm-A_0sTg5veRMtGWSMLBnsbeJKKck8PRFCH9O'
      },
      paypalButton: true,
      items: [],
      carritoValido: false,
      paypalStyle: {
        size: 'large', // small | medium | large | responsive
        shape: 'rect', // pill | rect
        color: 'gold' // gold | blue | silver | black
      },
      formaPago: 'paypal',
      photos: [],
      temporal: []
    }
  },
  watch: {
    'storage.carrito': {
      handler () {
        this.calcularTotal()
        this.validarBotonCarrito()
      },
      deep: true
    },
    'tipoEnvio': {
      deep: true,
      handler (val) {
        this.calcularTotal()
        this.validarBotonCarrito()
      }
    }
  },
  methods: {
    moment: moment,
    async init () {
      this.master = await this.$api.master()
      this.storage.usuario = {
        tarjeta: {
          numero: '',
          expira: '',
          cvv: ''
        }
      }

      this.calcularTotal()
      this.validarBotonCarrito()
      setTimeout(() => {
        this.paypalButton = false
      }, 500)
    },
    validarCorreo (correo) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(correo)
    },
    validarTelefono (numero) {
      var re = /^\d{10}$/
      return re.test(numero)
    },
    calcularTotal () {
      let carrito = _.cloneDeep(this.storage.carrito)
      this.storage.transaccion.promos = []
      this.ahorro = 0

      function total (carrito) {
        return carrito.reduce((valorAnterior, valorActual, indice, vector) => {
          let price = valorActual.price || valorActual.Price
          if (valorActual.ida_articles && valorActual.medidaExtra) {
            return (valorAnterior + (price))
          } else {
            return valorAnterior + price
          }
        }, 0)
      }

      this.articulosPromo = _.flatten(Object.keys(this.master.PROMOCIONES).map(categoria => {
        let porcentaje = Number(this.master.PROMOCIONES[categoria].PORCENTAJE)
        let promocion = this.master.PROMOCIONES[categoria].TIPO
        let productos = _.sortBy(carrito.filter(itm => itm.cat === categoria.toLowerCase()), ['price'])

        if (promocion === '3x2' && productos.length) {
          let descuento = _.take(productos, Math.floor(productos.length / 3))
          productos = productos.map(producto => {
            if (descuento.find(itm => itm.cve === producto.cve)) {
              this.ahorro += Number(producto.price.toFixed(2))
              this.storage.transaccion.promos.push(`3x2 ${categoria.toLowerCase()}`)
              return Object.assign({ cve: producto.cve, tipo: promocion, price: 0 })
            }
          })
        } else if (promocion === '2x1/2' && productos.length) {
          let descuento = _.take(productos, Math.floor(productos.length / 2))
          productos = productos.map(producto => {
            if (descuento.find(itm => itm.cve === producto.cve)) {
              this.ahorro += Number((producto.price - Number((producto.price / 2).toFixed(2))).toFixed(2))
              this.storage.transaccion.promos.push(`2x1/2 ${categoria.toLowerCase()}`)
              return Object.assign({
                cve: producto.cve,
                tipo: promocion,
                price: Number((producto.price / 2).toFixed(2))
              })
            }
          })
        } else if (promocion === 'descuento' && productos.length) {
          productos = productos.map(producto => {
            if (producto.medidaExtra && producto.medidaExtra !== '') {
              producto.price += producto.price
            }

            this.ahorro += Number((producto.price * (porcentaje / 100)).toFixed(2))
            this.storage.transaccion.promos.push(`-${porcentaje}% ${categoria.toLowerCase()}`)
            return Object.assign({
              cve: producto.cve,
              tipo: 'porcentaje',
              porcentaje,
              price: Number((producto.price - (producto.price * ((porcentaje / 100)))).toFixed(2))
            })
          })
        }
        return _.compact(productos)
      }))

      let envio = 0
      let calculoTotal = total(carrito)

      if (this.tipoEnvio === 'paqueteria') {
        envio = this.master.GASTO_ENVIO_WEB
      }

      if (this.storage.cupon.valido && this.storage.cupon.porcentaje) {
        let porcentaje = Number(this.storage.cupon.porcentaje) / 100
        this.storage.transaccion.promos.push(`cupón: ${this.storage.cupon.codigo}, -${porcentaje * 100}%`)
        this.subtotal = this.total = (calculoTotal - this.ahorro) - ((calculoTotal - this.ahorro) * porcentaje) + envio
        this.ahorro = calculoTotal - this.total
      } else {
        this.subtotal = this.total = calculoTotal - this.ahorro + envio
      }
    },
    async pagoCompletado (response) {
      // Habilitar
      this.$api.catalogo.restarStock(this.storage.carrito)
      // Agregamos campos extra a la respuesta de paypal
      response.promos = this.storage.transaccion.promos
      response.payer.payer_info.phone = this.storage.transaccion.payer.payer_info.phone || ''
      response.payer.payer_info.shipping_address.suburb = this.storage.transaccion.payer.payer_info.shipping_address.suburb || ''
      this.storage.transaccion = response

      this.ultimosPasos = true
      this.storage.venta = true
      // this.storage.carrito = []
      this.storage.usuario = {
        tarjeta: {
          numero: '',
          expira: '',
          cvv: ''
        }
      }
    },
    async finalizarVenta () {
      this.ultimosPasos = false
      if (this.storage.cupon.codigo) {
        this.$api.cupones.usar(this.storage.cupon.codigo)
      }
      this.$api.venta.registrar(JSON.stringify(this.storage.transaccion))
      // Habilitar
      this.enviarCorreo()
      this.$f7.views.main.router.navigate('/finalizar/', { reloadCurrent: true })
    },
    async pagarTarjeta () {
      this.pagando = true
      this.$f7.dialog.preloader('Un momento porfavor...')
      try {
        this.calcularTotal()

        const resp = await this.$api.payworks.pagar({
          // mode: 'AUT',
          mode: 'PRD',
          amount: this.total,
          entry_mode: 'MANUAL',
          card_number: this.storage.usuario.tarjeta.numero.replace(/-/g, ''),
          card_exp: this.storage.usuario.tarjeta.expira.replace(/\//g, ''),
          security_code: this.storage.usuario.tarjeta.cvv
        })

        if (resp.resultado_payw === 'A') {
          this.storage.transaccion.create_time = resp.date
          this.storage.transaccion.id = resp.id_afiliacion
          this.storage.transaccion.auth_code = resp.codigo_aut
          this.storage.transaccion.reference = resp.referencia
          this.storage.transaccion.state = 'approved'
          this.storage.transaccion.payer.payer_info.shipping_address.recipient_name = this.storage.transaccion.payer.payer_info.first_name + ' ' + this.storage.transaccion.payer.payer_info.last_name
          this.storage.transaccion.transactions = [{
            amount: {
              total: this.total,
              currency: 'MXN'
            },
            item_list: {
              items: this.items
            }
          }]

          this.pagando = false
          this.$f7.dialog.close()
          this.pagoCompletado(this.storage.transaccion)
        } else if (resp.resultado_payw === 'R') {
          this.pagando = false
          this.$f7.dialog.close()
          this.$f7.dialog.alert(decodeURI(resp.texto).replace(/\+/g, ' ').replace('había', 'ha'))
        } else {
          this.pagando = false
          this.$f7.dialog.close()
          this.$f7.dialog.alert(decodeURI(resp.texto).replace(/\+/g, ' '))
        }
      } catch (err) {
        this.pagando = false
        this.$f7.dialog.close()
        this.$f7.dialog.alert('No se puedo completar la transacción, intenta más tarde.')
      }
    },
    agregarDireccionEnvio () {
      this.storage.transaccion.payer.payer_info.card_details = _.cloneDeep(this.storage.transaccion.payer.payer_info.shipping_address)
      setTimeout(() => {
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'city', '')
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'country_code', '')
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'line1', '')
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'postal_code', '')
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'state', '')
        this.$set(this.storage.transaccion.payer.payer_info.shipping_address, 'suburb', '')
      }, 250)
    },
    validarBotonCarrito () {
      this.carritoValido = true

      this.storage.carrito.forEach(itm => {
        if (itm.cat !== 'aretes' && itm.cat !== 'pulso' && itm.cat !== 'cadenas' && itm.cat !== 'diamante' && itm.cat !== 'dijes') {
          if (itm.medida === undefined || itm.medida === '') {
            this.carritoValido = false
          }
        }
      })

      if (this.carritoValido) {
        this.items = this.storage.carrito.map(itm => {
          let price = itm.price ? itm.price.toFixed(2) : itm.Price.toFixed(2)

          let item = this.articulosPromo.find(item => item.cve === itm.cve)
          if (item) {
            price = Number(item.price).toFixed(2)
          }
          if (this.storage.cupon.valido) {
            price = Number(price - (price * (this.storage.cupon.porcentaje / 100)).toFixed(2))
          }

          let description = ''
          if (itm.name) {
            description = itm.name + ', '
          }
          if (itm.medida) {
            description += 'medida: ' + itm.medida
            if (itm.grabado === 'grabado' && itm.grabado1 !== '') {
              description += ' , grabado: ' + itm.grabado1
            }
          } else {
            description = itm.cat.charAt(0).toUpperCase() + itm.cat.slice(1) || 'El artículo no cuenta con descripción'
          }
          if (itm.cat === 'diamante') {
            itm.cve = `SKU: ${itm.ItemID}, Certificado: ${itm.Certificate}`
            itm.name = `Diamante ${itm.Cut}`
            description = `${itm.Carat} quilates, claridad ${itm.Clarity}, color ${itm.Color}, corte ${itm.MakeCutGrade}`
          }
          return {
            cve: itm.cve,
            name: itm.cve,
            description,
            quantity: '1',
            price: price,
            currency: 'MXN'
          }
        })

        this.items.push(...this.storage.carrito.map(itm => {
          if (itm.medida && itm.medida !== '' && itm.medidaExtra && itm.medidaExtra !== '') {
            let description = ''
            if (itm.name) {
              description = itm.name + ', '
            }
            description += 'medida: ' + itm.medidaExtra
            if (itm.grabado === 'grabado' && itm.grabado2 !== '') {
              description += ' , grabado: ' + itm.grabado2
            }
            return {
              name: itm.cve,
              description,
              quantity: '1',
              price: itm.price.toFixed(2),
              currency: 'MXN'
            }
          }
        }))

        if (this.tipoEnvio === 'paqueteria') {
          this.items.push({
            name: 'Envío',
            description: 'Envío por paquetería',
            quantity: '1',
            price: '300.00',
            currency: 'MXN'
          })
        } else if (this.tipoEnvio === 'tienda') {
          this.items.push({
            name: 'Envío',
            description: 'Recogo mi pedido en tienda',
            quantity: '1',
            price: '0.00',
            currency: 'MXN'
          })
        }

        this.items = this.items.filter(Boolean)
        this.items = this.items.map(itm => _.omit(itm, ['cve']))
      } else {
        this.items = []
      }
    },
    enviarCorreo (alerta = false) {
      this.storage.transaccion.transactions[0].item_list.items = this.storage.transaccion.transactions[0].item_list.items.map(itm => {
        let art = this.storage.carrito.find(item => item.cve === itm.name)

        if (!_.isUndefined(art)) {
          return Object.assign({}, itm, { image: art.image })
        } else {
          return itm
        }
      })

      let items = ''
      this.storage.transaccion.transactions[0].item_list.items.forEach(itm => {
        items += `
        <table data-module="product-plain-lg0" width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation">
          <tbody>
              <tr>
                  <td class="o_bg-light o_px-xs" align="center" data-bgcolor="Bg Light" style="background-color: #dbe5ea;padding-left: 8px;padding-right: 8px;">
                      <!--[if mso]><table width="432" cellspacing="0" cellpadding="0" border="0" role="presentation"><tbody><tr><td><![endif]-->
                      <table class="o_block-xs" width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="max-width: 432px;margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td class="o_re o_bg-white o_px o_pt" align="center" data-bgcolor="Bg White" style="font-size: 0;vertical-align: top;background-color: #ffffff;padding-left: 16px;padding-right: 16px;padding-top: 16px;">
                                <div class="o_col o_col-2" style="display: inline-block;vertical-align: top;width: 100%;max-width: 200px;">
                                  <div class="o_px-xs o_sans o_text o_center" data-size="Text Default" data-min="12" data-max="20" style="font-family: Helvetica, Arial, sans-serif;margin-top: 0px;margin-bottom: 0px;font-size: 16px;line-height: 24px;text-align: center;padding-left: 8px;padding-right: 8px;">
                                    <p style="margin-top: 0px;margin-bottom: 0px;">
                                      <a class="o_text-primary" href="https://madai.mx/" data-color="Primary" style="text-decoration: none;outline: none;color: #1d2244;">
                                      <img src="https://madai.mx/assets/images/${itm.image}" width="184" height="184" alt="" style="max-width: 184px;-ms-interpolation-mode: bicubic;vertical-align: middle;border: 0;line-height: 100%;height: auto;outline: none;text-decoration: none;">
                                      </a>
                                    </p>
                                  </div>
                                </div>
                                <div class="o_col o_col-2" style="display: inline-block;vertical-align: top;width: 100%;max-width: 200px;">
                                  <div style="font-size: 24px; line-height: 24px; height: 24px;">&nbsp; </div>
                                  <div class="o_px-xs o_sans o_text o_text-light o_left o_xs-center" data-color="Light" data-size="Text Default" data-min="12" data-max="20" style="font-family: Helvetica, Arial, sans-serif;margin-top: 0px;margin-bottom: 0px;font-size: 16px;line-height: 24px;color: #82899a;text-align: left;padding-left: 8px;padding-right: 8px;">
                                    <h4 class="o_heading o_text-dark o_mb-xxs" data-color="Dark" data-size="Heading 4" data-min="10" data-max="26" style="font-family: Helvetica, Arial, sans-serif;font-weight: bold;margin-top: 0px;margin-bottom: 4px;color: #1d2244;font-size: 18px;line-height: 23px;">${itm.name}</h4>
                                    <p class="o_text-secondary o_mb-xs" data-color="Secondary" style="color: #424651;margin-top: 0px;margin-bottom: 8px;">${itm.description}</p>
                                    <p class="o_text-md o_text-primary" data-color="Primary" data-size="Text MD" data-min="15" data-max="23" style="font-size: 19px;line-height: 28px;color: #1d2244;margin-top: 0px;margin-bottom: 0px;"><strong>${itm.price}</strong></p>
                                  </div>
                                </div>
                                <div class="o_px-xs" style="padding-left: 8px;padding-right: 8px;">
                                  <table width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation">
                                    <tbody>
                                      <tr>
                                        <td class="o_re o_bb-light" style="font-size: 16px;line-height: 16px;height: 16px;vertical-align: top;border-bottom: 1px solid #d3dce0;" data-border-bottom-color="Border Light">&nbsp; </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if mso]></td></tr></table><![endif]-->
                    </td>
                </tr>
            </tbody>
        </table>
        `
      })

      let correo = {
        asunto: `Detalles de la compra ${this.storage.transaccion.id}`,
        para: this.storage.transaccion.payer.payer_info.email,
        order: this.storage.transaccion.id,
        name: this.storage.transaccion.payer.payer_info.first_name + ' ' + this.storage.transaccion.payer.payer_info.last_name,
        subtotal: this.storage.transaccion.transactions[0].amount.total,
        shipping: 0,
        total: this.storage.transaccion.transactions[0].amount.total,
        email: this.storage.transaccion.payer.payer_info.email,
        line: this.storage.transaccion.payer.payer_info.shipping_address.line1,
        city: this.storage.transaccion.payer.payer_info.shipping_address.city,
        suburb: this.storage.transaccion.payer.payer_info.shipping_address.suburb,
        state: this.storage.transaccion.payer.payer_info.shipping_address.state,
        cp: this.storage.transaccion.payer.payer_info.shipping_address.postal_code,
        phone: this.storage.transaccion.payer.payer_info.phone,
        items
      }

      this.storage.carrito = []

      window.emailjs.send('madai_no_reply', 'custom_template_1', correo)
        .then(response => {
          if (alerta) {
            this.$f7.dialog.alert('Se ha actualizado la información...', `MADAI`, () => {})
          }
          console.log('SUCCESS!', response.status, response.text)
        }, error => {
          this.$f7.dialog.alert('No pudimos actualizar la información, intenta mas tarde...', `MADAI`, () => {})
          console.log('FAILED...', error)
        })
    },
    abrirGaleria (galeria) {
      this.photos = galeria.map(url => {
        return {
          url: `//madai.mx/assets/images/${url}`
        }
      })

      setTimeout(() => {
        this.$refs.standaloneDark.open()
      }, 500)
    },
    formatearTarjeta (value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,16}/g)
      var match = (matches && matches[0]) || ''
      var parts = []
      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
      }
      if (parts.length) {
        return parts.join('-')
      } else {
        return value
      }
    },
    formatearFecha (value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{2,4}/g)
      var match = (matches && matches[0]) || ''
      var parts = []
      for (let i = 0, len = match.length; i < len; i += 2) {
        parts.push(match.substring(i, i + 2))
      }
      if (parts.length) {
        return parts.join('/')
      } else {
        return value
      }
    },
    validarCupon (codigo) {
      clearTimeout(timer)

      timer = setTimeout(async () => {
        try {
          let cupon = await this.$api.cupones.validar(codigo)
          if (cupon.cve === codigo) {
            this.storage.cupon = Object.assign(this.storage.cupon, {
              porcentaje: cupon.percent,
              valido: cupon.total > 0
            })
          } else {
            this.storage.cupon = Object.assign(this.storage.cupon, {
              porcentaje: 0,
              valido: false
            })
          }
          this.calcularTotal()
        } catch (err) {}
      }, 450)
    }
  },
  async created () {
    this.init()
  }
}
</script>

<style>
.list input[type="number"] {
  text-align: left;
}

.item-content-p-0 > .item-content {
  padding-left: 0 !important;
}

.green .item-input-info {
  color: rgb(65, 173, 73) !important;
  font-weight: bold;
}
</style>
